<div class="mb-2">
    <div class="d-flex justify-content-between">
        <div class="btn-toolbar">
            <div class="aconto-selector me-2">
                <select class="form-select form-select-sm" (change)="onAcontoType($event.target.value)">
                    <option selected value="-1">Alle</option>
                    <option value="0">Mdr</option>
                    <option value="1">Kvt</option>
                    <option value="2">1/2 år</option>
                    <option value="3">År</option>
                </select>
            </div>
            <app-month-picker placeholder="mm-åå" (monthChange)="onAcontoDate($event)"></app-month-picker>
        </div>
        <div class="btn-toolbar">
            <button type="button" class="btn btn-sm btn-primary" (click)="onAcontoBulk()">Lav fakturaer</button>
        </div>
    </div>
</div>
